// extracted by mini-css-extract-plugin
export default {"externalLink":"styles_externalLink__KfBzi"};